import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class KeyboardServiceService {

  currentModel: string = '';
  initKeyBoardValue: string = '';
  isNumberPad: boolean = false;

  private keyboardSource = new BehaviorSubject<string>(this.initKeyBoardValue);
  keyboardValue = this.keyboardSource.asObservable();

  constructor() { }

  changeValue(message: string) {
    this.keyboardSource.next(message)
  }

  unsubKeyboard () {
    this.keyboardSource.unsubscribe();
  }

  getCurrentModel () {
    return this.currentModel;
  }

  resetValue() {
    this.initKeyBoardValue = '';
    this.isNumberPad = false;
    this.keyboardSource.next('');
  }

  deleteValue(model) {
    return model.substring(0, model.length - 1);
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/keyboard-service/keyboard-service.service.ts